export const SET_PHONE_NUMBER = 'SET_PHONE_NUMBER';

export const setPhoneNumber = (phoneNumber) => {
	return {
		type: SET_PHONE_NUMBER,
		phoneNumber,
	};
};
